;(function () {
  'use strict'

  angular.module('contrast.log-enhancer').constant('LOG_ENHANCER_LEVELS', [
    { value: 4, name: 'Error' },
    { value: 3, name: 'Warn' },
    { value: 2, name: 'Info' },
    { value: 1, name: 'Debug' },
    { value: 0, name: 'Trace' }
  ])
})()
